import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth';
import { AppSplash } from './AppSplash';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Hold until the session check resolves, otherwise a signed-in user gets
  // bounced to /login on every hard refresh. It used to hold by rendering
  // nothing, which is the same thing as a blank white page for however long the
  // request takes.
  if (loading) return <AppSplash />;

  if (!user) {
    // Carry the attempted path so sign-in returns here. The server validates it
    // is site-relative before honouring it.
    const next = `${location.pathname}${location.search}`;
    const suffix = next === '/' ? '' : `?next=${encodeURIComponent(next)}`;
    return <Navigate to={`/login${suffix}`} replace />;
  }

  return <>{children}</>;
}
